export const ERROR_CODE_IDENTIFIANT = 'ERROR_IDENTIFIANT';
export const ERROR_CODE_EMAIL = 'ERROR_EMAIL';
export const ERROR_USER_NOT_EXISTE = 'USER_NOT_EXISTE';
export const ERROR_USER_HAS_ACTIVE = 'USER_HAS_ACTIVE';
export const ERROR_USER_HAS_DESACTIVE = 'USER_HAS_DESACTIVE';
export const ERROR_USER_PWD_CONTAIN_FIRST_LAST_NAME = 'USER_PWD_CONTAIN_FIRST_LAST_NAME';